import axios from "../axios";

export const find = (id, password) => {
    return axios.get('/api/protected?id=' + id + '&password=' + password);
};
